import * as React from 'react';

const TextChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="text-chunky_svg__eds-icon--text-chunky_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="text-chunky_svg__eds-icon--text-chunky_base"
            d="M4 4v4h2V6h5v12H9v2h6v-2h-2V6h5v2h2V4z"
        />
    </svg>
);

TextChunkySvg.displayName = 'TextChunkySvg';
export default TextChunkySvg;
